import { useEffect, useState } from "react";
import api from "./api";

/**
 * Liefert die Liste der bestätigten Arbeitgeber (employment_links mit status
 * "confirmed") eines Vermittlers. Für andere Rollen leer. Genutzt vom globalen
 * Header-Workspace-Switcher und dem „Firma"-Tab im Vermittler-Dashboard.
 */
export default function useConfirmedEmployers(user) {
    const [employers, setEmployers] = useState([]);
    useEffect(() => {
        let alive = true;
        if (!user || user === false || user.role !== "vermittler") {
            setEmployers([]);
            return;
        }
        api.get("/vermittler/employment")
            .then((r) => {
                if (!alive) return;
                const seen = new Set();
                const confirmed = (r.data.items || [])
                    .filter((l) => l.status === "confirmed")
                    .map((l) => ({ dealer_id: l.dealer_id, dealer_name: l.dealer_name, permissions: l.permissions || [] }))
                    .filter((e) => {
                        if (seen.has(e.dealer_id)) return false;
                        seen.add(e.dealer_id);
                        return true;
                    });
                setEmployers(confirmed);
            })
            .catch(() => { if (alive) setEmployers([]); });
        return () => { alive = false; };
    }, [user]);
    return employers;
}
